import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import {
    AppState,
    AuthenticationState,
    getLoginProvider,
} from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { UserSettingProps } from '../../../user-setting'

export const queryClient = new QueryClient()

export interface CreateAccountPageCtaProps {
    userSettings?: UserSettingProps

    LoginContent: () => React.ReactElement<any>
    VerifyEmailContent: (auth0Id: string) => React.ReactElement<any>
    SaveNameContent: (auth0Id: string) => React.ReactElement<any>
}

export const CreateAccountCTA: React.FC<CreateAccountPageCtaProps> = (
    props,
) => {
    return (
        <QueryClientProvider client={queryClient}>
            <CreateAccountCTAInternal {...props} />
        </QueryClientProvider>
    )
}

const CreateAccountCTAInternal: React.FC<CreateAccountPageCtaProps> = ({
    userSettings,

    LoginContent,
    VerifyEmailContent,
    SaveNameContent,
}) => {
    const {
        isLoggedIn,
        isLoading,
        emailVerified,
        hasUserName,
        wanUserId: auth0Id,
    } = useSelector<AppState, AuthenticationState>(
        (state) => state.authentication,
    )

    const isExternalAuthProvider = getLoginProvider(auth0Id) !== 'Auth0'

    if (isLoading) return null

    if (!isLoggedIn) {
        return LoginContent()
    }

    if (!emailVerified) {
        return VerifyEmailContent(auth0Id)
    }

    if (!hasUserName && userSettings && !isExternalAuthProvider) {
        return SaveNameContent(auth0Id)
    }

    return null
}
